<template>
  <div class="passenger-body">
    <div class="octobus__columns">
      <div class="octobus__column">
        <div class="octobus__field">
          <label class="octobus__label is-size-7-touch has-text-grey has-text-weight-light" :for="`passenger__name_${id}`">{{$t('passengerForm.name')}}</label>
          <p class="octobus__control has-icons-left is-expanded">
            <input
              :class="{
                'is-danger': errors.has(`passenger__name_${id}`),
                'is-primary': !errors.has(`passenger__name_${id}`) && fields[`passenger__name_${id}`] && fields[`passenger__name_${id}`].dirty
              }"
              v-validate="'required'"
              class="octobus__input is-medium"
              type="text"
              :placeholder="$t('passengerForm.name')"
              :id="`passenger__name_${id}`"
              :name="`passenger__name_${id}`"
              v-model="name"
            >
            <span class="octobus__icon is-small is-left">
              <font-awesome-icon
                :icon="userIcon"
              />
            </span>
          </p>
          <p v-show="errors.has(`passenger__name_${id}`)" class="octobus__help is-danger">{{ errors.first(`passenger__name_${id}`) }}</p>
        </div>
      </div>
      <div class="octobus__column">
        <div class="octobus__field">
          <label class="octobus__label is-size-7-touch has-text-grey has-text-weight-light" :for="`passenger__surname_${id}`">{{$t('passengerForm.lastname')}}</label>
          <p class="octobus__control has-icons-left is-expanded">
            <input
              :class="{
                'is-danger': errors.has(`passenger__surname_${id}`),
                'is-primary': !errors.has(`passenger__surname_${id}`) && fields[`passenger__surname_${id}`] && fields[`passenger__surname_${id}`].dirty
              }"
              v-validate="'required'"
              class="octobus__input is-medium"
              type="text"
              :placeholder="$t('passengerForm.lastname')"
              :id="`passenger__surname_${id}`"
              :name="`passenger__surname_${id}`"
              v-model="lastName"
            >
            <span class="octobus__icon is-small is-left">
              <font-awesome-icon
                :icon="userIcon"
              />
            </span>
          </p>
          <p v-show="errors.has(`passenger__surname_${id}`)" class="octobus__help is-danger">{{ errors.first(`passenger__surname_${id}`) }}</p>
        </div>
      </div>
      <div class="octobus__column is-hidden-touch">&nbsp;</div>
    </div>
    <div class="octobus__columns" v-if="isDocNeed && !loading.doctypes && !loading.countries">
      <div class="octobus__column">
        <div class="octobus__field">
          <label class="octobus__label is-size-7-touch has-text-grey has-text-weight-light" :for="`passenger__doctype_${id}`">{{$t('passengerForm.doctype')}}</label>
          <div class="octobus__select is-medium octobus__control is-fullwidth">
            <select
              v-validate="'required'"
              :name="`passenger__doctype_${id}`"
              :id="`passenger__doctype_${id}`"
              v-model="docType"
              @change="setField($event, 'docType')"
            >
              <option :value="doc.id" v-for="doc of doctypes" :key="doc.id">{{doc.name}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="octobus__column">
        <div class="octobus__field">
          <label class="octobus__label is-size-7-touch has-text-grey has-text-weight-light" :for="`passenger__passport_${id}`">{{$t('passengerForm.docnumber')}}</label>
          <p class="octobus__control">
            <input
              :class="{
                'is-danger': errors.has(`passenger__passport_${id}`),
                'is-primary': !errors.has(`passenger__passport_${id}`) && fields[`passenger__passport_${id}`] && fields[`passenger__passport_${id}`].dirty
              }"
              v-validate="'required'"
              class="octobus__input is-medium"
              type="text"
              :placeholder="$t('passengerForm.docnumber')"
              :id="`passenger__passport_${id}`"
              :name="`passenger__passport_${id}`"
              @change="setField($event, 'passport')"
            >
          </p>
          <p v-show="errors.has(`passenger__passport_${id}`)" class="octobus__help is-danger">{{ errors.first(`passenger__passport_${id}`) }}</p>
        </div>
      </div>
      <div class="octobus__column">
        <div class="octobus__field">
          <label class="octobus__label is-size-7-touch has-text-grey has-text-weight-light" :for="`passenger__citizen_${id}`">{{$t('passengerForm.citizenship')}}</label>
          <div class="octobus__select is-medium octobus__control is-fullwidth">
            <select
              v-validate="'required'"
              :name="`passenger__citizen_${id}`"
              :id="`passenger__citizen_${id}`"
              v-model="citizen"
              @change="setField($event, 'citizen')"
            >
              <option :value="citizen.id" v-for="citizen of countries" :key="citizen.id">{{citizen.name}}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="octobus__columns" v-if="isDocNeed && !loading.doctypes && !loading.countries">
      <div class="octobus__column is-one-third">
        <div class="octobus__field">
          <label class="octobus__label is-size-7-touch has-text-grey has-text-weight-light" :for="`passenger__birthDay_${id}`">{{$t('passengerForm.birthdaydate')}}</label>
          <p class="octobus__control">
            <input
              :class="{
                'is-danger': errors.has(`passenger__birthDay_${id}`),
                'is-primary': !errors.has(`passenger__birthDay_${id}`) && fields[`passenger__birthDay_${id}`] && fields[`passenger__birthDay_${id}`].dirty
              }"
              class="octobus__input is-medium"
              type="text"
              :placeholder="$t('passengerForm.birthdaydateplace')"
              :id="`passenger__birthDay_${id}`"
              :name="`passenger__birthDay_${id}`"
              v-model="birthDay"
              v-validate="'required|birthDay'"
              v-mask="mask"
              @change="setField($event, 'birthDay')"
            >
          </p>
          <p v-show="errors.has(`passenger__birthDay_${id}`)" class="octobus__help is-danger">{{ errors.first(`passenger__birthDay_${id}`) }}</p>
        </div>
      </div>
      <div class="octobus__column">
        <div class="octobus__control sex">
          <label for="" class="octobus__label is-size-7-touch has-text-grey has-text-weight-light">
            {{$t('passengerForm.sex')}}
          </label>
          <input class="is-checkradio" :id="`man_${id}`" type="radio" :name="`passenger__sex_${id}`" checked="checked" @change="setSex('M', 'sex')">
          <label :for="`man_${id}`">{{$t('passengerForm.man')}}</label>
          <input class="is-checkradio" :id="`woman_${id}`" type="radio" :name="`passenger__sex_${id}`" @change="setSex('F', 'sex')">
          <label :for="`woman_${id}`">{{$t('passengerForm.woman')}}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import AwesomeMask from 'awesome-mask';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { faUser } from '@fortawesome/fontawesome-free-solid';

export default {
  name: 'PassengerBody',
  inject: ['$validator'],
  directives: {
    mask: AwesomeMask,
  },
  components: {
    FontAwesomeIcon,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    passenger: {
      type: Number,
      default() {
        return 1;
      },
    },
    isDocNeed: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      sex: 'M',
      docType: '9',
      citizen: 'RU',
      birthDay: '',
      mask: '99-99-9999',
      doctypes: [],
      countries: [],
      loading: {
        doctypes: true,
        countries: true,
      },
      name: '',
      lastName: '',
    };
  },
  watch: {
    name(newVal) {
      this.$emit('setPersonalInfo', {
        value: newVal,
        field: 'name',
      });
    },
    lastName(newVal) {
      this.$emit('setPersonalInfo', {
        value: newVal,
        field: 'lastName',
      });
    },
  },
  methods: {
    setField(event, field) {
      const { value } = event.target;

      this[field] = value;
      this.$emit('setPersonalInfo', {
        value,
        field,
      });
    },
    setSex(value, field) {
      this.$emit('setPersonalInfo', {
        value,
        field,
      });
      this.sex = value;
    },
    isNumber(value) {
      return typeof value === 'number'
         && Number.isFinite(value)
         && !(value % 1);
    },
  },
  computed: {
    userIcon() {
      return faUser;
    },
  },
  created() {
    if (this.isDocNeed) {
      api.Content.doctypes()
        .then((res) => {
          this.loading.doctypes = false;
          this.doctypes = res;
          return true;
        });
      api.Content.countries()
        .then((res) => {
          this.loading.countries = false;
          this.countries = res;
          return true;
        });
    } else {
      this.loading.countries = false;
      this.loading.doctypes = false;
    }

    const user = this.$userData || this.$EventBus.$userData;

    if (user && this.passenger === 1) {
      this.name = user.name;
      this.lastName = user.surname;
    }
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Passenger/PassengerForm.vue